import React, {
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';

import { forEach } from 'lodash';
import PropTypes from 'prop-types';

import { Modal } from '~/components';
import api from '~/services/api';

import Forms from './Forms';

const DialogConfirmation = React.forwardRef((props, ref) => {
  const { title, keys, redux, query, params } = props;

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const modalRef = useRef(null);
  const dispatch = useDispatch();

  const handleOpen = useCallback((values) => {
    setData(values);
    modalRef.current.handleOpenModal(values);
  }, []);

  const handleSubmit = useCallback(
    async (value) => {
      try {
        setLoading(true);

        const url = [];

        forEach(keys, (key) => {
          url.push(data[key]);
        });

        const datalocal = url.join('/');

        const idcliente = data?.idcliente;
        const idmovimentacao = data?.idmovimentacao;
        const idposto = data?.idposto;
        const idatendimento = data?.idatendimento;

        // const nota = await api.get(`amaggisabastecimentosexternos/${request}`);

        const changedNota = {
          idcliente,
          idmovimentacao,
          idposto,
          idatendimento,
          justificativa: value.justificativa,
        };

        dispatch(redux(changedNota, params));

        modalRef.current.handleCloseModal();
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    },
    [data, query, keys]
  );

  useImperativeHandle(ref, () => ({
    handleOpen,
  }));

  return (
    <Modal
      form
      ref={modalRef}
      title={title}
      loading={loading}
      component={Forms}
      onForm={handleSubmit}
      maxWidth="sm"
    />
  );
});

DialogConfirmation.propTypes = {
  title: PropTypes.string.isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  redux: PropTypes.func.isRequired,
  query: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DialogConfirmation;
